export const useFormulation = (product) => {
    const f = product?.formulation || {};
    const web = product?.website || {};
    const combos = (f.combos || [])
        .filter((c) => c.is_active !== false)
        .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
    const comboMap = Object.fromEntries(combos.map((c) => [c.id, c]));
    const ingredients = (f.ingredients || [])
        .filter((i) => i.visible !== false)
        .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
    const byCombo = combos.reduce((acc, c) => {
        acc[c.id] = ingredients.filter((i) => i.combo_id === c.id);
        return acc;
    }, {});
    const actives = ingredients
        .filter((i) => i.is_botanical)
        .sort((a, b) => (b.premium ? 1 : 0) - (a.premium ? 1 : 0));
    return {
        // Combos are optional — a flat single-formula product still gets the full treatment.
        enabled: f.enabled !== false && (combos.length > 0 || ingredients.length > 0),
        sections: f.sections || {},
        basisLabel: f.basis_label || "per tablet",
        combos, comboMap, ingredients, byCombo, actives,
        usageSteps: f.usage_steps || [],
        usageNote: f.usage_note || "",
        criticalWarning: f.critical_warning || "",
        warnings: f.warnings || [],
        disclaimer: f.disclaimer || "",
        trademarks: f.trademarks || [],
        signatureLine: web.signature_line || "",
        scienceText: web.science_text || "",
    };
};
